import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { Role } from 'merlin-library';
import { ViewEditPatientProfileComponent } from 'projects/clinician/src/app/patient-list/manual-patient-enroll/view-edit-patient-profile/view-edit-patient-profile.component';
import { RemoteLoginComponent } from 'projects/clinician/src/app/my-account/remote-login/remote-login.component';
import { ImpersonateComponent } from './impersonate/impersonate.component';
import { SignoutComponent } from './signout/signout.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { UnAuthorizedComponent } from './unauthorized/unauthorized.component';
import { OneTimeWizardComponent } from './one-time-wizard/one-time-wizard.component';
import { OneTimeWizardSuccessComponent } from './one-time-wizard-success/one-time-wizard-success.component';
import { LegacyComponent } from './legacy/legacy.component';
import { RedirectSsoTechsupportComponent } from './redirect-sso-techsupport/redirect-sso-techsupport.component';

const routes: Routes = [
    {
        path: 'base',
        loadChildren: () =>
            import('./oidc-base/oidc.module').then((m) => m.OidcModule),
    },
    { path: '', redirectTo: 'base', pathMatch: 'full' },
    { path: 'impersonate', component: ImpersonateComponent },
    { path: 'redirect-sso-techsupport', component: RedirectSsoTechsupportComponent},
    {
        path: '',
        component: ShellComponent,
        children: [
            {
                path: 'clinician',
                loadChildren: () =>
                    import(
                        './../../projects/clinician/src/app/recent-transmission/recent-transmission.module'
                    ).then((m) => m.RecentTransmissionModule),
                data: {
                    role: [Role.User],
                    breadcrumb: 'title.Recent_Transmissions',
                },
            },
            {
                path: 'patient-list',
                loadChildren: () =>
                    import(
                        './../../projects/clinician/src/app/patient-list/patient-list.module'
                    ).then((m) => m.PatientListModule),
                data: { role: [Role.User], breadcrumb: 'label.gb.pat_list' },
            },
            {
                path: 'communication-center',
                loadChildren: () =>
                    import(
                        './../../projects/clinician/src/app/communication-center/communication-center.module'
                    ).then((m) => m.CommunicationCenterModule),
                data: {
                    role: [Role.User],
                    breadcrumb: 'title.Communication_Center',
                },
            },
            {
                path: 'patient-profile/:id',
                component: ViewEditPatientProfileComponent,
                data: { breadcrumb: 'label.gb.patient_list' },
            },
            {
                path: 'tools',
                loadChildren: () =>
                    import(
                        './../../projects/clinician/src/app/tools/tools.module'
                    ).then((m) => m.ToolsModule),
                data: { role: [Role.User], breadcrumb: 'label.gb.tools' },
            },
            {
                path: 'home',
                loadChildren: () =>
                    import(
                        './../../projects/clinician/src/app/quick-link-dashboard/quick-link-dashboard.module'
                    ).then((m) => m.QuickLinkDashboardModule),
                data: { role: [Role.User], breadcrumb: 'Home' },
            },
            {
                path: 'my-account',
                loadChildren: () =>
                    import(
                        './../../projects/clinician/src/app/my-account/my-account.module'
                    ).then((m) => m.MyAccountModule),
                data: { mode:  localStorage?.getItem('MAM') ? localStorage?.getItem('MAM') : 'view' },
            },
            {
                path: 'remote-login',
                component: RemoteLoginComponent,
            },

            {
                path: 'clinic-admin',
                loadChildren: () =>
                    import(
                        './../../projects/clinician/src/app/clinic-admin/clinic-admin.module'
                    ).then((m) => m.ClinicAdminModule),
                data: {
                    role: [Role.User],
                    breadcrumb: 'label.gb.clin_administration',
                },
            },
        ],
    },
    {
        path: 'signout',
        component: SignoutComponent,
    },
    {
        path: 'terms-conditions',
        component: TermsConditionsComponent,
    },
    {
        path: 'one-time-wizard',
        component: OneTimeWizardComponent,
    },
    {
        path: 'one-time-wizard-success',
        component: OneTimeWizardSuccessComponent,
    },
    {
        path: 'unauthorized',
        component: UnAuthorizedComponent,
    },
    {
        path: 'legacy',
        component: LegacyComponent,
    },
    {
        path: 'reset-password',
        component: LegacyComponent,
    },
    { path: '**', redirectTo: '/', pathMatch: 'full' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
